"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultShareDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var react_intl_1 = require("react-intl");
var model_1 = require("../../model");
/**
 * @alpha
 */
exports.DefaultShareDialog = function (props) {
    var workspace = props.workspace, backend = props.backend, isVisible = props.isVisible, sharedObject = props.sharedObject, currentUser = props.currentUser, isLockingSupported = props.isLockingSupported, isCurrentUserWorkspaceManager = props.isCurrentUserWorkspaceManager, currentUserPermissions = props.currentUserPermissions, onApply = props.onApply, onCancel = props.onCancel, onError = props.onError, onInteraction = props.onInteraction;
    var locale = model_1.useDashboardSelector(model_1.selectLocale);
    var intl = react_intl_1.useIntl();
    var labels = react_1.useMemo(function () { return ({
        accessTypeLabel: intl.formatMessage({ id: "dashboard.shareDialog.lock.label" }),
        accessRegimeLabel: intl.formatMessage({
            id: "dashboard.shareDialog.underLenientControl.label",
        }),
        removeAccessCreatorTooltip: intl.formatMessage({
            id: "dashboard.shareDialog.removeAccessCreatorTooltip",
        }),
        removeAccessGranteeTooltip: intl.formatMessage({
            id: "dashboard.shareDialog.removeAccessGranteeTooltip",
        }),
    }); }, [intl]);
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement(sdk_ui_kit_1.ShareDialog, { locale: locale, backend: backend, workspace: workspace, sharedObject: sharedObject, currentUser: currentUser, onApply: onApply, onCancel: onCancel, onError: onError, isLockingSupported: isLockingSupported, labels: labels, isCurrentUserWorkspaceManager: isCurrentUserWorkspaceManager, currentUserPermissions: currentUserPermissions, onInteraction: onInteraction }));
};
//# sourceMappingURL=DefaultShareDialog.js.map